<template>
    <div style="width:100%;">

        <nav>

            <v-app-bar color="indigo" dark fixed app>
                <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title class="text-uppercase grey--text">
                    <span class="font-weight-light">ISSUES</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn text color="grey"
                    @click.prevent="toDocuments()">
                    <v-icon right>arrow_back</v-icon>
                </v-btn>



                <v-btn  v-if="view == 'header'" text color="grey"
                    @click.prevent="newIssue()">
                    <v-icon right>add_box</v-icon>
                </v-btn>

                <v-btn v-if="view == 'header'" text color="grey"
                    @click.prevent="refresh()">
                    <v-icon right>refresh</v-icon>
                </v-btn>

                <v-btn text color="grey"
                    @click.prevent="signOut">
                    <span>Sign out</span>
                    <v-icon right>exit_to_app</v-icon>
                </v-btn>

            </v-app-bar>

            <NavDraw :drawer="drawer" ></NavDraw>

        </nav>
        <v-container fluid>

            <div v-if="view=='header'">

                <v-layout column>
                    <v-flex>
                        <v-data-table
                            :headers="headers"
                            :items="issues"
                            :items-per-page="15"
                            :search="search"
                            class="elevation-1"
                            :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-arrow-collapse-left',
                            lastIcon: 'mdi-arrow-collapse-right',
                            prevIcon: 'mdi-minus',
                            nextIcon: 'mdi-plus'
                            }"                        

                        >

                            <template v-slot:top>
                                <v-text-field
                                v-model="search"
                                label="Search"
                                class="mx-4"
                                ></v-text-field>

                            </template>
                            <template v-slot:[`item.issueID`]="{ item }">
                                <v-chip
                                    color="warning"
                                    dark
                                    style="cursor:pointer;"
                                    @click="viewDetail(item)"
                                >
                                    {{ item.issueID }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon
                                    small
                                    @click="deleteIssueConfirm(item)"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>

                        </v-data-table>
                    </v-flex>

                </v-layout>

            </div>
            <div v-else-if="view=='detail'">
                <v-layout column>
                    <v-flex>
                        <IssueDet :issue="activeIssue" @close="view = 'header'"></IssueDet>
                    </v-flex>
                </v-layout>
            </div>
            <div v-else-if="view=='new'">
                <v-layout column>
                    <v-flex>
                        <IssueNew @close="closeIssueNew"></IssueNew>
                    </v-flex>
                </v-layout>
                
            </div>

        </v-container>

    </div>
</template>

<script>
import NavDraw from '@/components/NavDraw'
import {mapState, mapActions} from 'vuex'
//import DocFileDetail from './DocFileDetail'
import IssueDet from './IssueDet';
import IssueNew from './IssueNew';

const fb = require('../../firebaseConfig.js')

export default {
    components:{NavDraw,IssueDet,IssueNew},
    data(){
        return {
            drawer:false,
            view:"header",
            searchString:"",
            documents:[],
            //issues:[],
            activeIssue:null,
            icons:{
                excel: require('../../assets/excel-icon.png'),
                word: require('../../assets/word-icon.png'),
                pdf: require('../../assets/pdf-icon.png'),
                mindmap: require('../../assets/mindmap-icon.png')
            },
            headers:[
                {text:'ID',value:'issueID'},
                {text:'Issue',value:'issue'},
                {text:'Type',value:'issueType'},
                {text:'Brand',value:'brand'},
                {text:'Dept',value:'department'},
                {text:'Raised By',value:'raisedBy'},
                {text:'Date',value:'dateID'},
                {text:'Assigned To',value:'assignedTo'},
                {text:'Status',value:'status'},
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            search: '',
        }
    },
    computed:{
        ...mapState(['issues','currentUser'])
    },
    methods:{
        ...mapActions(['fetchIssues']),
        refresh(){
            //this.$store.dispatch('VIDEOS_GET');
            this.fetchIssues()
            
        },
        fetchIssuesLocal(){

            let issues = [];
            fb.issuesCollection.get()
            .then(colIssues=>{
                //console.log("docs",docs)
                colIssues.forEach(issue=>{
				
                    //console.log("issue",issue.data());

                        const data = {
                            'id':issue.id,
                            'issueID': issue.data().issueID,
                            'issue':issue.data().issue,
                            'issueType':issue.data().issueType,
                            'description':issue.data().description,
                            'department':issue.data().department,
                            'raisedBy':issue.data().raisedBy,
                            'status':issue.data().status,
                            'assignedTo':issue.data().assignedTo,
                            'creationDate':issue.data().creationDate.toDate(),
							'dateID':issue.data().dateID
                        }
                        issues.push(data);

                });
                
                issues.sort((a,b)=>(a.issueID > b.issueID) ? 1 : -1);
                this.issues = issues;

            })
        },
        newIssue(){
            this.view = "new";
        },
        viewDetail(issue){
            this.view = "detail";
            this.activeIssue = issue;
            //console.log("issue",issue)
        },
        closeIssueNew(val){
            //console.log("val",val)
            
            this.view = 'header'
            if (val && val != ''){
                this.fetchIssues();
            }

        },
        deleteIssueConfirm(item){
            this.$confirm('Are you sure you want to delete this issue?')
            .then(res=>{
                if (res){
                    this.deleteIssue(item)
                }
            })
        },
        deleteIssue(item){
            //console.log(item)
            fb.issuesCollection.doc(item.id).delete()
            .then(()=>{
                this.fetchIssues()
            })
        },
        signOut(){

            let self = this;
            fb.auth.signOut().then(function() {
                self.$router.push({name:'Login'})
            }).catch(function(error) {
                // An error happened.
                console.log(error.message)
            });

        },


    },
    created(){
        console.log("Issues Created")
    },
    mounted(){
        console.log("Issues mounted!");
        this.headerView = true;
        //console.log("this.currentUser.userType",this.currentUser)
        if ( !this.currentUser.userType || this.currentUser.userType != 'admin' ){
            this.$router.push('/issues')
        }
        this.fetchIssues()

    }
}
</script>

<style  scoped>

.row-header .col-header {
    background-color:black;
    color:white;
    font-weight: bold;
    text-align: center;
    padding-bottom: 5px;
    padding-top: 5px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.row-header .col-header2 {
    background-color:lightgray;
    color:black;
    font-weight: bold;
    font-size:medium;
    text-align: center;
}

.file-icon{
    width:40px;
    height: 40px;
    max-width: 40px;
    max-height: 40px;
}

.dv-clear{
    cursor: pointer;
}
.label-text{
    font-weight: bold;
}
.dv-message{
    font-weight: bold;
    font-size: 1.2rem;
    color:blue;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.errorMessage{
    color:red;
    border: 2px solid red;
    padding: 10px;
}

.emp-clear-status{
    color:blue;
    border: 2px solid red;
    font-weight: bold;
    padding: 5px;
}
</style>